// If isHighPrecision is true and value is 5,00,000, then the final output will be 0.5M
// If isHighPrecision is false and value is 5,00,000, then the final output will be 500k
export default function numberFormatter(value,startFrom='M', isHighPrecision = false) {
    const getValueCondition = (forSuffix) => {
        switch (forSuffix) {
            case 'Q': return !isHighPrecision ? value >= 1000000000000000 : value >= 1000000000000;
            case 'T': return !isHighPrecision ? value >= 1000000000000 : value >= 100000000000
            case 'B': return !isHighPrecision ? value >= 1000000000 : value >= 100000000
            case 'M': return !isHighPrecision ? value >= 1000000 : value >= 100000
            default: return value >= 1000;
        }
    }

    const getStartFromList=()=>{
        switch (startFrom) {
            case 'Q': return ['Q','T','B','M'] ;
            case 'T': return ['T','B','M'] 
            case 'B': return ['B','M'] 
            case 'M': return ['M'] 
            default: return ['Q','T','B','M'];
        }
    }
    const startFromList=getStartFromList()
    if (getValueCondition('Q') && startFromList.includes('Q')) {
        return { number: (value / 1000000000000000), suffix: 'Q' }
    }
    if (getValueCondition('T') && startFromList.includes('T')) {
        return { number: (value / 1000000000000), suffix: 'T' }
    }
    if (getValueCondition('B') && startFromList.includes('B')) {
        return { number: (value / 1000000000), suffix: 'B' }
    }
    if (getValueCondition('M') && startFromList.includes('M')) {
        return { number: (value / 1000000), suffix: 'M' }
    }
    if (value >= 1000) {
        return { number: (value / 1000), suffix: 'K' }
    }
    return { number: value, suffix: '' };
}